// extracted by mini-css-extract-plugin
module.exports = {"shadow":"LoadingSpinner_shadow__2l8r7","loadingSpinner":"LoadingSpinner_loadingSpinner__DOrSj"};